export const round5 = (x: number) => Math.round(x / 5) * 5;

export const formatInningNum = (inningNum: number) => {
  const num = Math.round(Math.floor(inningNum));
  let txt;
  if (num === 1) {
    txt = 'st';
  } else if (num === 2) {
    txt = 'nd';
  } else if (num === 3) {
    txt = 'rd';
  } else if (num > 3) {
    txt = 'th';
  } else {
    txt = 'th';
  }
  return `${num}${txt}`;
};

export const formatHalfInningNum = (inningNum: number | string) => {
  const num = Math.round(Math.floor(Number(inningNum)));
  let txt;
  if (num === 1) {
    txt = 'st';
  } else if (num === 2) {
    txt = 'nd';
  } else if (num === 3) {
    txt = 'rd';
  } else if (num > 3) {
    txt = 'th';
  } else {
    txt = 'th';
  }

  let prefix;
  if (inningNum.toString().includes('.5')) {
    prefix = '🔽';
  } else {
    prefix = '🔼';
  }
  return `${prefix} ${num}${txt}`;
};

export const getOrdinalSuffix = (day: number): string => {
  if (day > 3 && day < 21) {
    return 'th';
  }
  switch (day % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

export const toTitleCase = (str: string) => {
  return str.replace(/\w\S*/g, (txt) => {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const toSentenceCase = (str: string) => {
  return str !== null ? str.charAt(0).toUpperCase() + str.slice(1) : '';
};

export const truncateText = (str: string, maxLength: number = 18): string => {
  return str.length > maxLength ? `${str.slice(0, maxLength)}...` : str;
};

export const formatDownloadTitle = (titleString: string) => {
  return titleString.toLowerCase().replace(/ /g, '_');
};

export const getReadableInning = (i: number) => {
  const remainder = i % 2;
  const readable = (i - remainder) / 2 + 1;
  return { topBottom: remainder, inning: readable };
};

export const pluralize = (count: number, singular: string, plural: string) => {
  return count === 1 ? `${count} ${singular}` : `${count} ${plural}`;
};

export const getInternalInning = (inningNum: number, topBottom: number) =>
  (inningNum - 1) * 2 + topBottom;

export function updateAggregateValues(
  stats: {
    count: number;
    mean: number;
    m2: number;
    stddev: number;
    min: number;
    max: number;
  },
  value: number | null | undefined
) {
  if (value === null || value === undefined) {
    return stats;
  }

  let { count, mean, m2, stddev, min, max } = stats;

  if (value < min) {
    min = value;
  }
  if (value > max) {
    max = value;
  }
  count += 1;
  const delta = value - mean;
  mean += delta / count;
  const delta2 = value - mean;
  m2 += delta * delta2;
  if (count < 2) {
    stddev = 0;
  } else {
    stddev = Math.sqrt(m2 / (count - 1));
  }
  return {
    count,
    mean,
    m2,
    stddev,
    min,
    max,
  };
}
